import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V21.0284C20 22.2485 18.6209 22.9581 17.6281 22.249L12 18.2289L6.37186 22.249C5.37906 22.9581 4 22.2485 4 21.0284V5ZM7 4C6.44772 4 6 4.44772 6 5V20.0568L11.1281 16.3939C11.6497 16.0213 12.3503 16.0213 12.8719 16.3939L18 20.0568V5C18 4.44772 17.5523 4 17 4H7Z"
	})
});
export default SvgBookmarkLine;
